<template>
    <div id="app" style="height: 100%">
        <div class="fixed-header">
            <div class="header-left-bar">欢迎您！
                <span v-if="userId != null">{{ userName }}<a href="javascript:;" @click="logout">&nbsp;[退出]</a></span>
                <span v-else><a href="javascript:;" @click="login">登录</a>&nbsp;<a target="_blank" href="//upass.10jqka.com.cn/register">注册</a></span>
            </div>
            <div class="header-right-bar">
                <a href="//x.10jqka.com.cn/stockpick?qs=return_stock">
                    i问财首页
                </a>
                <span class="top-bar-img bar-separator"></span>

                <a href="//x.10jqka.com.cn/stockpick?tid=stockpick&ts=1&qs=pc_~soniu~stock~stock~znxg~topbar&zhineng=opened">
                    <span class="top-bar-img bar-intelligent"></span>
                    智能查找
                </a>
                <span class="top-bar-img bar-separator"></span>

                <a href="/backtest/app.html#/strategysquare" :style="$route.name === 'strategysquare' ? topActiveStyle : {}">
                    <span class="top-bar-img bar-invest"></span>
                    投资策略
                </a>
                <span class="top-bar-img bar-separator"></span>

                <a href="/backtest/app.html#/backtest?qs=backtest_menu2" :style="$route.name === 'backtest' ? topActiveStyle : {}">
                    <span class="top-bar-img bar-backtest"></span>
                    策略回测
                </a>
                <span class="top-bar-img bar-separator"></span>

                <a href="//x.10jqka.com.cn/yuqingmonitor/query-favorites?type=0&qs=favorite_entry">
                    <span class="top-bar-img bar-mystrategy"></span>
                    我的策略
                </a>
                <span class="top-bar-img bar-separator"></span>

                <a href="https://xtz.10jqka.com.cn/pc/home">
                    <span class="top-bar-img bar-school"></span>
                    股民学校
                </a>
                <span class="top-bar-img bar-separator"></span>
            </div>
        </div>

        <header-nav></header-nav>
        <div class="routerbody">
            <div class="routerbodymain">
                <keep-alive>
                    <router-view v-if="$route.meta.keepAlive"/>
                </keep-alive>
                <router-view v-if="!$route.meta.keepAlive"/>
                <footer-nav></footer-nav>
            </div>
        </div>
        <qr-code></qr-code>
        <feed-back></feed-back>
    </div>
</template>
<script>
    /* eslint-disable no-undef */
    import header from './components/common/header'
    import footer from './components/common/footer'
    // import io from 'socket.io-client'

    export default {
        name: 'app',
        data () {
            return {
                topActiveStyle: {
                    color: '#0a5db0'
                }
            }
        },
        components: {
            'header-nav': header,
            'footer-nav': footer
        },
        // created () {
        //     const socket = io('/', {
        //         transports: [ 'websocket' ]
        //     })
        //     socket.emit('xxx', {xxx: 'xxx'})
        //     socket.on('news', function (data) {
        //         console.log(data)
        //     })
        // },
        computed: {
            userId () {
                return this.$store.getters['userInfo/userId']
            },
            userName () {
                return this.$store.getters['userInfo/userName']
            }
        },
        methods: {
            logout () {
                document.location.href = '//upass.10jqka.com.cn/logout?redir=' + document.location.href
            },
            login () {
                // ThsLogin.showLoginBox('//' + document.domain + '/reload.html')
                window.LoginInstance.show()
            }
        }
    }
</script>

<style lang="scss">
    @import 'scss/common/base.scss';
    .fixed-header a {
        color: #6c6c6c;
        &:hover {
            color: #227fc7;
        }
    }
</style>




// WEBPACK FOOTER //
// src/App.vue